import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Attendance from "@/pages/Attendance";
import Tasks from "@/pages/Tasks";
import Payroll from "@/pages/Payroll";
import Employees from "@/pages/Employees";
import Feedback from "@/pages/Feedback";
import Communications from "@/pages/Communications";
import Meetings from "@/pages/Meetings";
import Billing from "@/pages/Billing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCallback from "@/pages/PaymentCallback";
import PayPalCapture from "@/pages/PayPalCapture";
import Leave from "@/pages/Leave";
import Workplaces from "@/pages/Workplaces";
import Hardware from "@/pages/Hardware";
import Scan from "@/pages/Scan";
import PlatformAdmin from "@/pages/PlatformAdmin";
import Security from "@/pages/Security";
import Profile from "@/pages/Profile";
import Administrators from "@/pages/Administrators";
import PersonalAdmin from "@/pages/PersonalAdmin";
import Chat from "@/pages/Chat";
import Legal from "@/pages/Legal";
import Support from "@/pages/Support";
import Reports from "@/pages/Reports";
import CompanySettings from "@/pages/CompanySettings";

function App() {
  useEffect(() => {
    document.title = "QwikLogs Africa";
    const t = setInterval(() => {
      if (document.title !== "QwikLogs Africa") document.title = "QwikLogs Africa";
    }, 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/payment/paypal" element={<PayPalCapture />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/security" element={<ProtectedRoute><Security /></ProtectedRoute>} />
            <Route path="/platform-admin" element={<ProtectedRoute><PlatformAdmin /></ProtectedRoute>} />
            <Route path="/control-center" element={<ProtectedRoute><PlatformAdmin /></ProtectedRoute>} />
            <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="leave" element={<Leave />} />
              <Route path="workplaces" element={<Workplaces />} />
              <Route path="hardware" element={<Hardware />} />
              <Route path="security" element={<Security />} />
              <Route path="employees" element={<Employees />} />
              <Route path="administrators" element={<Administrators />} />
              <Route path="profile" element={<Profile />} />
              <Route path="personal" element={<PersonalAdmin />} />
              <Route path="chat" element={<Chat />} />
              <Route path="support" element={<Support />} />
              <Route path="reports" element={<Reports />} />
              <Route path="company" element={<CompanySettings />} />
              <Route path="legal" element={<Legal />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="announcements" element={<Communications />} />
              <Route path="meetings" element={<Meetings />} />
              <Route path="billing" element={<Billing />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
